module.exports = __webpack_public_path__ + "img/rzl.074d0dc6.svg";